import { Injectable } from '@angular/core';
import { isEqual } from 'lodash';
import { IDatiqGraph } from '../../../models';
import { DatiqGraphAmChartsService } from './datiq-graph-am-charts.service';

@Injectable({
    providedIn: 'root',
})
export class DatiqGraphService {
    constructor(private _am: DatiqGraphAmChartsService) {}

    init(): string {
        return this._am.init();
    }

    create(
        id: string,
        rootElement: HTMLElement,
        settings: IDatiqGraph
    ): string {
        this._am.create(id, rootElement, settings);

        return id;
    }

    update(id: string, rootElement: HTMLElement, settings: IDatiqGraph) {
        this._am.update(id, rootElement, settings);
    }

    shouldGraphUpdate(
        id: string,
        currentSettings: IDatiqGraph,
        previousSettings: IDatiqGraph
    ): boolean {
        return !!id?.length && !isEqual(currentSettings, previousSettings);
    }

    dispose(id: string) {
        this._am.dispose(id);
    }
}
